export default __webpack_public_path__ + "static/media/KR.f800f628.svg";